export default "__VITE_ASSET__CopXKQXl__"